(function(){
    'use strict';

    var autoCompleteSegmentRoute = {
        templateUrl: 'app/components/autocomplete/segmentRoute/segmentRoute.html',
        controller: autoCompleteSegmentRouteController,
        controllerAs: 'vm',
        bindings:{
            ngModel: '=',
            isOriginDestiny: '=',
            isModalOpen: '=',
            originId: '=',
            destinyId: "=",
            target: '@',
            index: '=',
            placeholder: '@',
            onEventSegmentRoute: '&'
        }
    };

    angular
        .module('completeAir')
        .component('autoCompleteSegmentRoute', autoCompleteSegmentRoute);

    autoCompleteSegmentRouteController.$inject = ['$element', 'stretchAssistantService', 'routeService', '$timeout','linkService'];

    function autoCompleteSegmentRouteController($element, stretchAssistantService, routeService, $timeout,linkService){
        var vm = this;

        vm.$onInit = function(){
            vm.selectItem = null;
        }

        vm.appendToBody = function() {
            return vm.isModalOpen == undefined ? true : false;
        }

        vm.getSegmentRouteOrigin = function (search) {
            vm.selectItem = null;
            return stretchAssistantService.search(search)
                .then(function(res){
                    return vm.ignoredRepeatStretchAssistants(res.data._embedded.stretchAssistants);
                });
        }

        vm.getSegmentRouteDestiny = function (search) {
            vm.selectItem = null;
            if(vm.originId !== 0){
                return stretchAssistantService.searchDestiny(vm.originId, search)
                    .then(function(res){
                        return res.data._embedded.stretchAssistants;
                    });
            }
        }

        vm.ignoredRepeatStretchAssistants = function (stretchAssistants) {
            var auxStretchAssistants = [];
            var equal = 0;
            angular.forEach(stretchAssistants,function(stretchAssistant){
                if(equal !== linkService.getLinkId(stretchAssistant._embedded.airports[0]._links.self.href)){
                    auxStretchAssistants.push(stretchAssistant);
                    equal = linkService.getLinkId(stretchAssistant._embedded.airports[0]._links.self.href);
                }
            });
            return auxStretchAssistants;
        }

        vm.onSegmentRouteSelect = function (item, model, label, event) {
            vm.selectItem = model;
            vm.ngModel = label;
            vm.onEventSegmentRoute({segmentRoute: vm.selectItem, isOriginDestiny: vm.isOriginDestiny, index: vm.index});
        }

        vm.onSegmentRouteBlur = function () {
            $timeout(function () {
                if(vm.selectItem === null) {
                    vm.selectItem = null;
                    vm.ngModel = null;
                    vm.onEventSegmentRoute({segmentRoute: vm.selectItem, isOriginDestiny: vm.isOriginDestiny, index: vm.index});
                }
            }, 150);
        }
    }
})();
